// @flow
import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '../../customer-form/get-phone-number-normalizer';

const UGANDA: Country = {
  code: 'ug',
  customerForm: {
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(20),
    },
  },
};

export default UGANDA;
